/* eslint-disable react/prop-types */
import { Form } from '@unform/web';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { FaAngleDown } from 'react-icons/fa';

import { Row, TabContent, TabPane } from 'reactstrap';
import { toast } from 'react-hot-toast';
import * as Yup from 'yup';

import api from '~/services/api';
import getValidationErrors from '~/services/getValidationErrors';
import { Tabs } from 'ui-kit-takeat';
import { useAuth } from '~/context/AuthContext';
import {
  Button,
  Checkbox,
  Divider,
  IconChevronRight,
  IconChevronUp,
  IconInfoFilled,
  Input,
} from 'takeat-design-system-ui-kit';
import CheckboxInput from '~/components/Form/Checkbox';
import {
  ScreenTwo,
  ScreenOne,
  ButtonsArea,
  StyledTable,
  InputStyled,
  CheckboxInputStyled,
  ScreenThree,
  ScreenTitle,
  KdsInfoArea,
  InputLine,
  ViewArea,
  ViewAreaTitle,
  ViewAreaSubtitle,
  View,
  KdsItems,
  KitchenItem,
  StepItem,
  Footer,
} from './styles';
import { StepsContainer } from '../../styles';

const CheckState = {
  On: 0,
  Off: 1,
  Partial: 2,
};

function EditKitchen({ toggleModalEditKitchen, kdsState }) {
  const [kdsName, setKdsName] = useState(kdsState?.name);
  const [kdsAverageTime, setKdsAverageTime] = useState(kdsState?.average_time);
  const [activeScreen, setActiveScreen] = useState(1);
  const { user } = useAuth();

  const [groupItems, setGroupItems] = useState(kdsState?.group_items || false);

  const [kdsNotifyWhatsapp, setKdsNotifyWhatsapp] = useState(
    kdsState?.notify_whatsapp || false
  );

  const [kdsNotifySound, setKdsNotifySound] = useState(
    kdsState?.notify_sound || false
  );

  const [kdsAutoStart, setKdsAutoStart] = useState(
    kdsState?.auto_start || false
  );

  const [arrayCategories, setArrayCategories] = useState([]);

  const getCategories = useCallback(async () => {
    const response = await api.get(
      `/restaurants/kds/product-categories/${kdsState?.id}`
    );

    const categories = response.data;

    setArrayCategories(categories);
  }, [kdsState]);

  const [arrayComplementCategories, setArrayComplementCategories] = useState(
    []
  );

  const getComplementCategories = useCallback(async () => {
    const response = await api.get(
      `/restaurants/kds/complement-categories/${kdsState?.id}`
    );

    const categories = response.data;

    setArrayComplementCategories(categories);
  }, []);

  useEffect(() => {
    getCategories();
  }, [getCategories]);

  useEffect(() => {
    getComplementCategories();
  }, [getComplementCategories, user]);

  const [categoryExpanded, setCategoryExpanded] = useState(null);

  function toggleExpand(id) {
    if (categoryExpanded === id) {
      setCategoryExpanded(null);
    } else {
      setCategoryExpanded(id);
    }
  }

  const [complementCategoryExpanded, setComplementCategoryExpanded] =
    useState(null);

  function toggleExpandComplementCategory(id) {
    if (complementCategoryExpanded === id) {
      setComplementCategoryExpanded(null);
    } else {
      setComplementCategoryExpanded(id);
    }
  }
  const [stepsToSubmit, setStepsToSubmit] = useState(kdsState.kds_steps);
  const [allChecked, setAllChecked] = useState(false);
  const [allComplementsChecked, setAllComplementsChecked] = useState(false);

  const updateAll = useRef(false);

  useEffect(() => {
    if (!updateAll.current) {
      return;
    }

    updateAll.current = false;

    if (allChecked === CheckState.On) {
      setArrayCategories((categs) => {
        for (const item of categs) {
          item.checked = true;
          for (const product of item.products) {
            product.checked = true;
          }
        }

        return categs.slice();
      });
    } else if (allChecked === CheckState.Off) {
      setArrayCategories((categs) => {
        for (const item of categs) {
          item.checked = false;
          for (const product of item.products) {
            product.checked = false;
          }
        }

        return categs.slice();
      });
    }
  }, [allChecked]);

  useEffect(() => {
    if (!updateAll.current) {
      return;
    }

    updateAll.current = false;

    if (allComplementsChecked === CheckState.On) {
      setArrayComplementCategories((categs) => {
        for (const item of categs) {
          item.checked = true;
          for (const complement of item.complements) {
            complement.checked = true;
          }
        }

        return categs.slice();
      });
    } else if (allComplementsChecked === CheckState.Off) {
      setArrayComplementCategories((categs) => {
        for (const item of categs) {
          item.checked = false;
          for (const complement of item.complements) {
            complement.checked = false;
          }
        }

        return categs.slice();
      });
    }
  }, [allComplementsChecked]);

  useEffect(() => {
    const checkedCount = arrayCategories.reduce(
      (acc, item) => (item.checked ? acc + 1 : acc),
      0
    );

    if (checkedCount === 0) {
      setAllChecked(CheckState.Off);
    } else if (checkedCount === arrayCategories.length) {
      setAllChecked(CheckState.On);
    } else {
      setAllChecked(CheckState.Partial);
    }
  }, [arrayCategories]);

  useEffect(() => {
    const checkedCount = arrayComplementCategories.reduce(
      (acc, item) => (item.checked ? acc + 1 : acc),
      0
    );

    if (checkedCount === 0) {
      setAllComplementsChecked(CheckState.Off);
    } else if (checkedCount === arrayComplementCategories.length) {
      setAllComplementsChecked(CheckState.On);
    } else {
      setAllComplementsChecked(CheckState.Partial);
    }
  }, [arrayComplementCategories]);

  function handleCheckCategory(id, old_status) {
    setArrayCategories((categs) => {
      const found = categs.find((cat) => cat.product_category_id === id);

      if (!found) {
        return categs;
      }

      if (old_status) {
        found.checked = false;

        for (const product of found.products) {
          product.checked = false;
        }
      } else {
        found.checked = true;

        for (const product of found.products) {
          product.checked = true;
        }
      }

      return categs.slice();
    });
  }

  function handleCheckComplementCategory(id, old_status) {
    setArrayComplementCategories((categs) => {
      const found = categs.find((cat) => cat.complement_category_id === id);

      if (!found) {
        return categs;
      }

      if (old_status) {
        found.checked = false;

        for (const complement of found.complements) {
          complement.checked = false;
        }
      } else {
        found.checked = true;

        for (const complement of found.complements) {
          complement.checked = true;
        }
      }

      return categs.slice();
    });
  }

  function handleCheckProduct(category_id, product_id, old_status) {
    setArrayCategories((categs) => {
      const found = categs.find(
        (cat) => cat.product_category_id === category_id
      );

      if (!found || !found.products) {
        return categs;
      }

      const productFound = found.products.find(
        (prod) => prod.product_id === product_id
      );

      if (!productFound) {
        return categs;
      }

      productFound.checked = !old_status;

      const checkedCount = found.products.reduce(
        (acc, prod) => (prod.checked ? acc + 1 : acc),
        0
      );

      found.checked = checkedCount !== 0;

      return categs.slice();
    });
  }

  function handleCheckComplement(category_id, complement_id, old_status) {
    setArrayComplementCategories((categs) => {
      const found = categs.find(
        (cat) => cat.complement_category_id === category_id
      );

      if (!found || !found.complements) {
        return categs;
      }

      const complementeFound = found.complements.find(
        (comp) => comp.complement_id === complement_id
      );

      if (!complementeFound) {
        return categs;
      }

      complementeFound.checked = !old_status;

      const checkedCount = found.complements.reduce(
        (acc, comp) => (comp.checked ? acc + 1 : acc),
        0
      );

      found.checked = checkedCount !== 0;

      return categs.slice();
    });
  }

  const [viewMode, setViewMode] = useState(kdsState?.view_mode);

  const formRef = useRef(null);

  function handleChangeCategoryPreparationTime(id, value) {
    setArrayCategories((cat) => {
      const newArray = [...cat];
      const categoyFind = newArray.findIndex(
        (cat) => cat.product_category_id === id
      );

      newArray[categoyFind].average_time = value;

      return [...newArray];
    });
  }

  function handleChangeComplementCategoryPreparationTime(id, value) {
    setArrayComplementCategories((cat) => {
      const newArray = [...cat];
      const categoyFind = newArray.findIndex(
        (cat) => cat.complement_category_id === id
      );

      newArray[categoyFind].average_time = value;

      return [...newArray];
    });
  }

  function handleChangeProductPreparationTime(category_id, product_id, value) {
    setArrayCategories((cat) => {
      const newArray = [...cat];
      const categoyFind = newArray.findIndex(
        (cat) => cat.product_category_id === category_id
      );

      const productFind = newArray[categoyFind].products.findIndex(
        (prod) => prod.product_id === product_id
      );

      newArray[categoyFind].products[productFind].average_time = value;

      return [...newArray];
    });
  }

  function handleChangeComplementPreparationTime(
    category_id,
    complement_id,
    value
  ) {
    setArrayCategories((cat) => {
      const newArray = [...cat];
      const categoyFind = newArray.findIndex(
        (cat) => cat.complement_category_id === category_id
      );

      const complementFind = newArray[categoyFind].complements.findIndex(
        (comp) => comp.complement_id === complement_id
      );

      newArray[categoyFind].complements[complementFind].average_time = value;

      return [...newArray];
    });
  }

  function handleGetAllProductsChecked(id) {
    const categoryFind = arrayCategories.find(
      (category) => category.product_category_id === id
    );

    const allCheckedItems = categoryFind.products.every((item) => item.checked);

    return allCheckedItems;
  }

  function handleGetAllComplementsChecked(id) {
    const categoryFind = arrayComplementCategories.find(
      (category) => category.complement_category_id === id
    );

    const allCheckedItems = categoryFind?.complements.every(
      (item) => item.checked
    );

    return allCheckedItems;
  }

  const handleSubmit = useCallback(async () => {
    if (activeScreen === 1) {
      try {
        if (kdsState?.parent_kds_id) {
          try {
            if (!kdsName) {
              toast.error('Digite o nome do KDS');
              return;
            }

            const response = await api.put(`restaurants/kds/${kdsState.id}`, {
              average_time: kdsAverageTime,
              name: kdsName,
              notify_sound: kdsNotifySound,
              auto_start: kdsAutoStart,
            });

            const {
              average_time,
              group_items,
              name,
              notify_whatsapp,
              view_mode,
              auto_start,
              kds_steps,
            } = response.data;

            kdsState.name = name;
            kdsState.average_time = average_time;
            kdsState.group_items = group_items;
            kdsState.notify_whatsapp = notify_whatsapp;
            kdsState.auto_start = auto_start;
            kdsState.view_mode = view_mode;
            kdsState.kds_steps = kds_steps;

            toast.success('Tela atualizada com sucesso');
            toggleModalEditKitchen();
          } catch (error) {
            toast.error('Erro ao atualizar tela');
            console.log(error);
          }
        } else {
          setActiveScreen(2);
        }
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          if (formRef.current) {
            formRef.current.setErrors(errors);
          }
        }
      }
    } else {
      // Obs.: Para reduzir o tamanho do body, é usado esse formato no lugar de objetos
      const productsMinimalInfo = arrayCategories
        .filter((item) => item.checked && item.products.length > 0)
        .map((pc) => {
          return [
            pc.product_category_id,
            !!pc.checked,
            pc.average_time || 0,
            pc.products.map((p) => {
              return [p.product_id, !!p.checked, p.average_time || 0];
            }),
          ];
        });

      const complementsMinimalInfo = arrayComplementCategories
        .filter((item) => item.checked && item.complements.length > 0)
        .map((cc) => {
          return [
            cc.complement_category_id,
            !!cc.checked,
            cc.average_time || 0,
            cc.complements.map((c) => {
              return [c.complement_id, !!c.checked, c.average_time || 0];
            }),
          ];
        });

      try {
        if (!kdsName) {
          toast.error('Digite o nome do KDS');
          return;
        }

        if (!kdsAverageTime && !kdsState.is_operational) {
          toast.error('Preencha o tempo médio');
          return;
        }
        const response = await api.put(`restaurants/kds/${kdsState.id}`, {
          average_time: kdsAverageTime,
          group_items: groupItems,
          name: kdsName,
          view_mode: 4,
          notify_whatsapp: kdsNotifyWhatsapp,
          notify_sound: kdsNotifySound,
          kds_steps: stepsToSubmit,
          auto_start: kdsAutoStart,
          product_categories: productsMinimalInfo,
          complement_categories: complementsMinimalInfo,
        });

        const {
          average_time,
          group_items,
          name,
          notify_whatsapp,
          view_mode,
          auto_start,
          kds_steps,
        } = response.data;

        kdsState.name = name;
        kdsState.average_time = average_time;
        kdsState.group_items = group_items;
        kdsState.notify_whatsapp = notify_whatsapp;
        kdsState.auto_start = auto_start;
        kdsState.view_mode = view_mode;
        kdsState.kds_steps = kds_steps;

        toast.success('Tela atualizada com sucesso');
        toggleModalEditKitchen();
      } catch (error) {
        toast.error('Erro ao atualizar tela');
        console.log(error);
      }
    }
  }, [
    activeScreen,
    arrayCategories,
    arrayComplementCategories,
    toggleModalEditKitchen,
    kdsState,
    kdsAutoStart,
    kdsAverageTime,
    kdsNotifyWhatsapp,
    kdsNotifySound,
    kdsName,
    groupItems,
    stepsToSubmit,
  ]);

  const [activeTab, setActiveTab] = useState(0);

  function handleSetSteps(id, key, value) {
    setStepsToSubmit((prevSteps) => {
      const existingIndex = prevSteps.findIndex((step) => step.id === id);

      if (existingIndex !== -1) {
        const updatedSteps = [...prevSteps];
        updatedSteps[existingIndex] = {
          ...updatedSteps[existingIndex],
          [key]: value,
        };
        return updatedSteps;
      }
      return [
        ...prevSteps,
        { id, auto_start: false, notify_sound: false, [key]: value },
      ];
    });
  }

  return (
    <Form onSubmit={handleSubmit} ref={formRef}>
      <ScreenOne active={activeScreen}>
        <InputLine>
          <span
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
            }}
          >
            <Input
              label="Nome do KDS"
              style={{ width: 768 }}
              value={kdsName}
              onChange={(e) => setKdsName(e.target.value)}
            />
          </span>
        </InputLine>
        <Divider style={{ marginTop: 21 }} />
        {kdsState.is_operational ? (
          <KdsInfoArea>
            <InputLine style={{ alignItems: 'flex-start', marginTop: 16 }}>
              {!kdsState?.parent_kds_id && (
                <Checkbox
                  name="group_items"
                  disabled={kdsNotifyWhatsapp}
                  label="Agrupar os itens do pedido"
                  checked={groupItems}
                  onChange={() => {
                    if (!kdsNotifyWhatsapp) {
                      setGroupItems(!groupItems);
                    } else {
                      setGroupItems(true);
                    }
                  }}
                  description="Se desmarcado, será exibido um item por vez"
                />
              )}
              <Checkbox
                checked={kdsNotifyWhatsapp}
                label="Notificação por whatsapp"
                onChange={() => {
                  if (!kdsNotifyWhatsapp) {
                    updateAll.current = true;

                    setGroupItems(true);
                    setAllChecked(CheckState.On);
                  }

                  setKdsNotifyWhatsapp(!kdsNotifyWhatsapp);
                }}
                containerStyles={{ width: '38%' }}
                description="O cliente será notificado via WhatsApp assim que a comanda for finalizada."
              />

              {/* <Checkbox
                checked={kdsNotifyWhatsapp}
                label="Finalização de Pedidos KDS despacha no delivery"
                containerStyles={{ width: '61%' }}
                labelStyles={{ width: 392 }}
                onChange={() => {
                  if (!kdsNotifyWhatsapp) {
                    updateAll.current = true;
                    setGroupItems(true);
                    setAllChecked(CheckState.On);
                  }

                  setKdsNotifyWhatsapp(!kdsNotifyWhatsapp);
                }}
                description="Habilite esta opção para permitir que os pedidos finalizados no KDS sejam despachados no delivery."
              /> */}
            </InputLine>
            <ViewArea>
              <ViewAreaTitle>Modo de visualização da etapa</ViewAreaTitle>
              <ViewAreaSubtitle>
                Veja como vai ficar a ordem das etapas do seu KDS Operacional.
              </ViewAreaSubtitle>
              <View>
                <p
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gapp: 10,
                  }}
                >
                  <IconChevronUp /> {kdsName || 'Etapas'}
                </p>
                <KdsItems>
                  {kdsState?.kds_steps?.map((_, index) => (
                    <>
                      <KitchenItem
                        key={index}
                        style={{ background: '#01AFFF' }}
                      >
                        <p style={{ textAlign: 'center' }}>Etapa {index + 1}</p>
                      </KitchenItem>
                      {index !== kdsState?.kds_steps.length - 1 && (
                        <IconChevronRight />
                      )}
                    </>
                  ))}
                </KdsItems>
              </View>
            </ViewArea>
          </KdsInfoArea>
        ) : (
          <KdsInfoArea>
            <InputLine style={{ alignItems: 'flex-start', width: 880 }}>
              {!kdsState?.parent_kds_id && (
                <Checkbox
                  name="group_items"
                  disabled={kdsNotifyWhatsapp}
                  label="Agrupar os itens do pedido"
                  checked={groupItems}
                  onChange={() => {
                    if (!kdsNotifyWhatsapp) {
                      setGroupItems(!groupItems);
                    } else {
                      setGroupItems(true);
                    }
                  }}
                  description="Se desmarcado, será exibido um item por vez"
                />
              )}

              <Checkbox
                name="notify_sound"
                checked={kdsNotifySound}
                onChange={() => {
                  setKdsNotifySound(!kdsNotifySound);
                }}
                label="Ativar som ao chegar novo pedido."
                description=""
              />

              <Checkbox
                name="auto_start"
                checked={kdsAutoStart}
                onChange={() => {
                  setKdsAutoStart(!kdsAutoStart);
                }}
                label="Aceitar pedidos automaticamente."
              />
            </InputLine>

            <InputLine style={{ alignItems: 'flex-start', marginTop: 16 }}>
              {!kdsState.parent_kds_id && (
                <Checkbox
                  checked={kdsNotifyWhatsapp}
                  label="Notificação por whatsapp"
                  onChange={() => {
                    if (!kdsNotifyWhatsapp) {
                      updateAll.current = true;

                      setGroupItems(true);
                      setAllChecked(CheckState.On);
                    }

                    setKdsNotifyWhatsapp(!kdsNotifyWhatsapp);
                  }}
                  containerStyles={{ width: '38%' }}
                  description="O cliente será notificado via WhatsApp assim que a comanda for finalizada."
                />
              )}

              {/* <Checkbox
                checked={kdsNotifyWhatsapp}
                label="Finalização de Pedidos KDS despacha no delivery"
                containerStyles={{ width: '61%' }}
                labelStyles={{ width: 392 }}
                onChange={() => {
                  if (!kdsNotifyWhatsapp) {
                    updateAll.current = true;

                    setGroupItems(true);
                    setAllChecked(CheckState.On);
                  }

                  setKdsNotifyWhatsapp(!kdsNotifyWhatsapp);
                }}
                description="Habilite esta opção para permitir que os pedidos finalizados no KDS sejam despachados no delivery."
              /> */}
            </InputLine>

            <Input
              label="Tempo médio (Em minutos)"
              containerStyles={{ marginTop: 16 }}
              value={kdsAverageTime}
              onChange={(e) => setKdsAverageTime(e.target.value)}
              info={
                <span style={{ display: 'flex', marginTop: 20 }}>
                  <IconInfoFilled />
                  <span>
                    Tempo médio de preparação dos pratos. Caso algum prato tenha
                    tempo específico, basta personalizar na próxima etapa.
                  </span>
                </span>
              }
            />
            <ViewArea style={{ marginTop: 38 }}>
              <ViewAreaTitle>Modo de visualização da etapa</ViewAreaTitle>
              <ViewAreaSubtitle>Veja como vai ficar seu KDS</ViewAreaSubtitle>
              <View>
                <p>KDS Tradicional</p>
                <KitchenItem>
                  <p style={{ textAlign: 'center' }}>
                    {kdsName || 'Praça Pizza'}
                  </p>
                </KitchenItem>
              </View>
            </ViewArea>
          </KdsInfoArea>
        )}
      </ScreenOne>

      <ScreenTwo active={activeScreen}>
        {!kdsState.parent_kds_id || kdsState.is_operational ? (
          <Row>
            <ScreenTitle>Tempo Personalizado</ScreenTitle>
            <p style={{ fontSize: 14 }}>
              Personalize o tempo de preparo para itens específicos. Essa etapa
              é opcional. Caso não seja definido será considerado a tempo médio
              definido na etapa anterior.
            </p>
          </Row>
        ) : (
          <ScreenTitle>Seleção de items</ScreenTitle>
        )}

        <Tabs
          containerStyles={{ marginTop: 10 }}
          tabs={['Produtos', 'Complementos']}
          selected={activeTab}
          onChangeTab={(e) => setActiveTab(e)}
          mediaQueries={[
            {
              maxWidth: 1024,
              styles: 'font-size: 12px; padding: 0 5px;',
            },
          ]}
          tabSelectedStyles={{
            borderBottom: '2px solid red',
            borderRadius: 0,
          }}
          tabStyles={{
            borderBottom: '2px solid transparent',
            boxShadow: '1px 1px 2px 0px rgba(0,0,0,0.1)',
          }}
        />

        <TabContent activeTab={activeTab} style={{ paddingBottom: 60 }}>
          <TabPane tabId={0}>
            <StyledTable>
              <thead>
                <tr>
                  <th>
                    <span
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        color: '#6c6c6c',
                      }}
                    >
                      {' '}
                      <CheckboxInputStyled
                        allChecksChecked={allChecked === CheckState.Partial}
                      >
                        <input
                          name="all_selected"
                          checked={allChecked !== CheckState.Off}
                          onChange={(e) => {
                            updateAll.current = true;

                            if (allChecked === CheckState.On) {
                              setAllChecked(CheckState.Off);
                            } else {
                              setAllChecked(CheckState.On);
                            }
                          }}
                          type="checkbox"
                        />
                      </CheckboxInputStyled>
                      Todos os itens
                    </span>
                  </th>
                  <th>Tempo de preparo</th>
                </tr>
              </thead>
              <tbody>
                {arrayCategories.map((category) => (
                  <React.Fragment key={category?.product_category_id}>
                    <tr>
                      <td>
                        {' '}
                        <span
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            color: '#6c6c6c',
                            fontWeight: 'bold',
                          }}
                        >
                          <FaAngleDown
                            size={16}
                            onClick={() => {
                              toggleExpand(category?.product_category_id);
                            }}
                            cursor="pointer"
                            style={{
                              transition: 'all 0.2s',
                              transform:
                                categoryExpanded ===
                                  category?.product_category_id
                                  ? 'rotate(-90deg)'
                                  : 'rotate(0)',
                              marginLeft: 22,
                              marginRight: 10,
                            }}
                          />
                          <CheckboxInputStyled
                            allChecksChecked={
                              !handleGetAllProductsChecked(
                                category?.product_category_id
                              )
                            }
                          >
                            <input
                              defaultChecked={category?.checked}
                              name={category?.name}
                              key={category?.checked}
                              value={category?.checked}
                              type="checkbox"
                              onClick={() => {
                                handleCheckCategory(
                                  category?.product_category_id,
                                  category?.checked
                                );
                              }}
                            />
                          </CheckboxInputStyled>

                          {category?.name}
                        </span>
                      </td>

                      <td>
                        {' '}
                        <InputStyled
                          type="number"
                          defaultValue={category?.average_time}
                          onChange={(e) =>
                            handleChangeCategoryPreparationTime(
                              category?.product_category_id,
                              e.target.value
                            )
                          }
                        />{' '}
                        min
                      </td>
                    </tr>

                    {category?.products &&
                      category?.products.map((product) => (
                        <tr
                          style={{
                            display:
                              categoryExpanded !==
                              category.product_category_id && 'none',
                          }}
                        >
                          <td style={{ border: 'none' }}>
                            {' '}
                            <span
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                color: '#6c6c6c',
                                paddingLeft: 55,
                              }}
                            >
                              <CheckboxInput
                                defaultChecked={product.checked}
                                name={`product_${product.product_id}`}
                                key={`product_${product.product_id}`}
                                value={product.checked}
                                disabled={kdsNotifyWhatsapp}
                                onClick={() =>
                                  handleCheckProduct(
                                    category.product_category_id,
                                    product.product_id,
                                    product.checked
                                  )
                                }
                              />{' '}
                              {product.name}
                            </span>
                          </td>
                          <td style={{ border: 'none' }}>
                            <InputStyled
                              defaultValue={product.average_time}
                              onChange={(e) =>
                                handleChangeProductPreparationTime(
                                  category.product_category_id,
                                  product.product_id,
                                  e.target.value
                                )
                              }
                              type="number"
                            />{' '}
                            min
                          </td>
                        </tr>
                      ))}
                  </React.Fragment>
                ))}
              </tbody>
            </StyledTable>
          </TabPane>
          <TabPane tabId={1}>
            <StyledTable>
              <thead>
                <tr>
                  <th>
                    <span
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        color: '#6c6c6c',
                      }}
                    >
                      {' '}
                      <CheckboxInputStyled
                        allChecksChecked={
                          allComplementsChecked === CheckState.Partial
                        }
                      >
                        <input
                          name="all_selected"
                          checked={allComplementsChecked !== CheckState.Off}
                          onChange={(e) => {
                            updateAll.current = true;

                            if (allComplementsChecked === CheckState.On) {
                              setAllComplementsChecked(CheckState.Off);
                            } else {
                              setAllComplementsChecked(CheckState.On);
                            }
                          }}
                          type="checkbox"
                        />
                      </CheckboxInputStyled>
                      Todos os itens
                    </span>
                  </th>

                  <th>Tempo de preparo</th>
                </tr>
              </thead>
              <tbody>
                {arrayComplementCategories.map((category) => (
                  <React.Fragment key={category?.complement_category_id}>
                    <tr>
                      <td>
                        {' '}
                        <span
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            color: '#6c6c6c',
                            fontWeight: 'bold',
                          }}
                        >
                          <FaAngleDown
                            size={16}
                            onClick={() => {
                              toggleExpandComplementCategory(
                                category?.complement_category_id
                              );
                            }}
                            cursor="pointer"
                            style={{
                              transition: 'all 0.2s',
                              transform:
                                complementCategoryExpanded ===
                                  category?.complement_category_id
                                  ? 'rotate(-90deg)'
                                  : 'rotate(0)',
                              marginLeft: 22,
                              marginRight: 10,
                            }}
                          />
                          <CheckboxInputStyled
                            allChecksChecked={
                              !handleGetAllComplementsChecked(
                                category?.complement_category_id
                              )
                            }
                          >
                            <input
                              defaultChecked={category?.checked}
                              name={category?.name}
                              key={category?.checked}
                              value={category?.checked}
                              type="checkbox"
                              onClick={() => {
                                handleCheckComplementCategory(
                                  category?.complement_category_id,
                                  category?.checked
                                );
                              }}
                            />
                          </CheckboxInputStyled>

                          {category?.name}
                        </span>
                      </td>

                      <td>
                        {' '}
                        <InputStyled
                          type="number"
                          defaultValue={category?.average_time}
                          onChange={(e) =>
                            handleChangeComplementCategoryPreparationTime(
                              category?.complement_category_id,
                              e.target.value
                            )
                          }
                        />{' '}
                        min
                      </td>
                    </tr>

                    {category?.complements &&
                      category?.complements.map((complement) => (
                        <tr
                          style={{
                            display:
                              complementCategoryExpanded !==
                              category.complement_category_id && 'none',
                          }}
                        >
                          <td style={{ border: 'none' }}>
                            {' '}
                            <span
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                color: '#6c6c6c',
                                paddingLeft: 55,
                              }}
                            >
                              <CheckboxInput
                                defaultChecked={complement.checked}
                                name={`complement_${complement.complement_id}`}
                                key={`complement_${complement.complement_id}`}
                                value={complement.checked}
                                disabled={kdsNotifyWhatsapp}
                                onClick={() =>
                                  handleCheckComplement(
                                    category.complement_category_id,
                                    complement.complement_id,
                                    complement.checked
                                  )
                                }
                              />{' '}
                              {complement.name}
                            </span>
                          </td>

                          <td style={{ border: 'none' }}>
                            <InputStyled
                              defaultValue={complement.average_time}
                              onChange={(e) =>
                                handleChangeComplementPreparationTime(
                                  category.complement_category_id,
                                  complement.complement_id,
                                  e.target.value
                                )
                              }
                              type="number"
                            />
                            min
                          </td>
                        </tr>
                      ))}
                  </React.Fragment>
                ))}
              </tbody>
            </StyledTable>
          </TabPane>
        </TabContent>
      </ScreenTwo>

      <ScreenThree active={activeScreen}>
        <ScreenTitle>Configurações das etapas</ScreenTitle>
        <StepsContainer>
          {stepsToSubmit?.map((step, index) => (
            <StepItem key={index}>
              <InputLine>
                <Input
                  type="text"
                  placeholder="Nome da etapa"
                  label={`Nome da etapa ${index + 1}`}
                  value={step.name}
                  style={{ width: '100%' }}
                  onChange={(e) => {
                    handleSetSteps(step.id, 'name', e.target.value);
                  }}
                  info={
                    <span
                      style={{
                        display: 'flex',
                        width: 376,
                        alignItems: 'center',
                        marginTop: 8,
                      }}
                    >
                      <IconInfoFilled />
                      <span style={{ width: 376 }}>
                        Dê um nome para a etapa. Exemplo: Massa.
                      </span>
                    </span>
                  }
                />
                <Input
                  type="number"
                  placeholder="Tempo de preparo"
                  label="Tempo de preparo da etapa"
                  value={step.average_time}
                  onChange={(e) => {
                    handleSetSteps(step.id, 'average_time', e.target.value);
                  }}
                  style={{ width: '100%' }}
                  info={
                    <span
                      style={{
                        display: 'flex',
                        width: 376,
                        alignItems: 'flex-start',
                        marginTop: 16,
                      }}
                    >
                      <IconInfoFilled />
                      <span style={{ width: 376 }}>
                        Caso algum item tenha tempo específico, basta
                        personalizar na próxima etapa.
                      </span>
                    </span>
                  }
                />
              </InputLine>
              <InputLine
                style={{
                  alignItems: 'flex-start',
                  width: 880,
                  marginTop: 32,
                }}
              >
                <Checkbox
                  name="notify_sound"
                  checked={step.notify_sound}
                  onChange={(e) => {
                    handleSetSteps(step.id, 'notify_sound', e.target.checked);
                  }}
                  label="Ativar som ao chegar novo pedido."
                  description=""
                />

                <Checkbox
                  name="auto_start"
                  checked={step.auto_start}
                  onChange={(e) => {
                    handleSetSteps(step.id, 'auto_start', e.target.checked);
                  }}
                  label="Aceitar pedidos automaticamente."
                />
              </InputLine>
              <Divider style={{ marginTop: 16 }} />
            </StepItem>
          ))}
        </StepsContainer>
      </ScreenThree>

      <Footer>
        <Divider />
        <ButtonsArea>
          <Button
            onClick={() => {
              toggleModalEditKitchen();
            }}
            type="button"
          >
            Cancelar
          </Button>

          {activeScreen === 1 &&
            (kdsState.parent_kds_id ? (
              <Button
                customColor="#2EC9B7"
                type="submit"
                style={{ marginLeft: 8 }}
              >
                Salvar
              </Button>
            ) : (
              <Button
                customColor="#2EC9B7"
                type="button"
                onClick={() => {
                  setActiveScreen(2);
                }}
              >
                Próximo
              </Button>
            ))}

          {activeScreen === 2 && !kdsState.is_operational && (
            <div style={{ display: 'flex' }}>
              <Button
                onClick={() => {
                  setActiveScreen(1);
                }}
                variant="outlined"
              >
                Voltar
              </Button>
              <Button
                customColor="#2EC9B7"
                type="submit"
                style={{ marginLeft: 8 }}
              >
                Salvar
              </Button>
            </div>
          )}

          {activeScreen === 2 &&
            (kdsState.parent_kds_id || kdsState.is_operational) && (
              <div style={{ display: 'flex' }}>
                <Button
                  onClick={() => {
                    setActiveScreen(1);
                  }}
                  variant="outlined"
                >
                  Voltar
                </Button>
                <Button
                  customColor="#2EC9B7"
                  type="button"
                  onClick={() => {
                    setActiveScreen(3);
                  }}
                  style={{ marginLeft: 8 }}
                >
                  Próximo
                </Button>
              </div>
            )}

          {activeScreen === 3 && (
            <div style={{ display: 'flex' }}>
              <Button
                onClick={() => {
                  setActiveScreen(2);
                }}
                variant="outlined"
              >
                Voltar
              </Button>
              <Button
                customColor="#2EC9B7"
                type="submit"
                style={{ marginLeft: 8 }}
              >
                Salvar
              </Button>
            </div>
          )}
        </ButtonsArea>
      </Footer>
    </Form>
  );
}

export default EditKitchen;